import { del, get, patch, post, put } from "./api";

const adminServiceNew = {
  generateQuestions: assistantId =>
    get({ endpoint: "/admin/back-office/questions-generator", params: { assistantId } }),
  getAccounts: ({ page, perPage }) => get({ endpoint: "/admin/accounts", params: { page, perPage } }),
  createAccount: ({ accountName, accountId, timezone, pageName }) =>
    post({ endpoint: "/admin/accounts", data: { accountName, accountId, timezone }, headers: { pageName } }),
  editAccount: ({ id, accountName, accountId, salesforceAccountId, timezone, accountType, sftpIpList, publicKey, pageName }) =>
    patch({ endpoint: `/admin/accounts/${id}`, data: { accountName, accountId, salesforceAccountId, timezone, accountType, sftpIpList, publicKey }, headers: { pageName } }),
  deleteAccount: ({ id, pageName }) => del({ endpoint: `/admin/accounts/${id}`, headers: { pageName } }),
  createCodelessAgent: (data, pageName) => post({ endpoint: "/admin/assistants", data, headers: { pageName } }),
  deleteAgent: (assistantId, pageName) => del({ endpoint: `/admin/assistants/${assistantId}/archive`, headers: { pageName } }),
  disableAgent: (assistantId, pageName) => patch({ endpoint: `/admin/assistants/${assistantId}/deactivate`, headers: { pageName } }),
  moveAgentToProduction: (assistantId, pageName) => patch({
    endpoint: `/admin/assistants/${assistantId}/v2/set-live`,
    headers: { pageName }
  }),
  moveAgentToStaging: (assistantId, pageName) => patch({ endpoint: `/admin/assistants/${assistantId}/reset`, headers: { pageName } }),
  fetchDeploymentSettings: (assistantId) => get({ endpoint: `/admin/assistants/${assistantId}/deployment-settings` }),
  updateDeploymentSettings: (assistantId, data) => put({ endpoint: `/admin/assistants/${assistantId}/deployment-settings`, data }),
  buildKg: (assistantId, pageName) => post({ endpoint: `/assistants/${assistantId}/deploy/kg`, headers: { pageName } })
};

export default adminServiceNew;
